<script setup>
import { useI18n } from 'vue-i18n';

defineProps({
  documents: { type: Array, default: () => [] },
});

defineOptions({ name: 'DetailDocumentsCard' });

const { t } = useI18n();

function humanize(value) {
  if (!value) return '';
  return value
    .toString()
    .replace(/_/g, ' ')
    .toLowerCase()
    .replace(/\b\w/g, c => c.toUpperCase());
}

function name(doc) {
  return humanize(doc.document_name || doc.name);
}
</script>

<template>
  <div>
    <div
      v-for="(doc, index) in documents"
      :key="index"
      class="flex items-center justify-between border-b border-gray-100 py-2 last:border-0"
    >
      <div>
        <p class="text-sm text-gray-900">{{ name(doc) }}</p>
        <p v-if="doc.document_type" class="text-xs text-gray-500">
          {{ humanize(doc.document_type) }}
        </p>
      </div>
      <a
        v-if="doc.document"
        :href="doc.document"
        target="_blank"
        rel="noopener noreferrer"
        class="text-xs font-medium text-[#71481d] hover:underline"
      >
        {{ t('ARDHISASA.LAND_PROCESSES.LAND_REGISTRATION.VIEW') }}
      </a>
    </div>
  </div>
</template>
